import {
    type NavigationItemRenderProps as SquideNavigationItemRenderProps,
    type NavigationLinkRenderProps as SquideNavigationLinkRenderProps,
    type NavigationSectionRenderProps as SquideNavigationSectionRenderProps,
    isNavigationLink as squideIsNavigationLink
} from "@squide/firefly";
import type { ReactNode } from "react";

export interface NavigationLinkAdditionalProps {
    icon?: ReactNode;
    badge?: ReactNode;
}

export interface NavigationSectionAdditionalProps {
    icon?: ReactNode;
}

export type NavigationLinkRenderProps = Omit<SquideNavigationLinkRenderProps, "additionalProps"> & {
    additionalProps: NavigationLinkAdditionalProps;
};

export type NavigationSectionRenderProps = Omit<SquideNavigationSectionRenderProps, "additionalProps"> & {
    additionalProps: NavigationSectionAdditionalProps;
};

export type NavigationItemRenderProps = NavigationLinkRenderProps | NavigationSectionRenderProps;

export function isNavigationLink(item: NavigationItemRenderProps): item is NavigationLinkRenderProps {
    return squideIsNavigationLink(item as SquideNavigationItemRenderProps);
}

export type RenderItemFunction = (
    item: NavigationItemRenderProps,
    key: string,
    index: number,
    level: number
) => ReactNode;
export type RenderSectionFunction = (elements: ReactNode[], key: string, index: number, level: number) => ReactNode;
